import { ReadingStatus } from 'infrastructure/enums';
import {
  useOverviewDashboardFilter,
  useRpmOverviewDashboardCount,
} from 'infrastructure/hooks/rpm/overview-dashboard';
import { useTranslation } from 'react-i18next';
import useUser from 'utils/useUser';

enum AllowedRole {
  Critical = 'critical',
  Risk = 'risk',
}

export const useButtons = () => {
  const { filter, updateFilter } = useOverviewDashboardFilter();
  const { isCriticalRole, isAtRiskRole } = useUser();
  const { count, isLoading } = useRpmOverviewDashboardCount(filter);
  const { t } = useTranslation();

  const { status } = filter;

  const isCritical = status === ReadingStatus.Critical;
  const isRisk = status === ReadingStatus.Risk;
  const isNormal = status === ReadingStatus.Normal;

  const onClick = async (newStatus: ReadingStatus) => {
    status === newStatus
      ? updateFilter({ status: undefined, page: undefined })
      : updateFilter({
          status: newStatus,
          page: undefined,
        });
  };

  let buttons = [
    {
      status: ReadingStatus.Critical,
      count: count?.critical ?? 0,
      active: isCritical,
      label: t('labels.critical'),
      bgColor: '#B20109',
      render: true,
      role: AllowedRole.Critical,
      onClick: () => onClick(ReadingStatus.Critical),
    },
    {
      status: ReadingStatus.Risk,
      count: count?.atRisk ?? 0,
      active: isRisk,
      label: t('labels.at-risk'),
      bgColor: '#FF7A00',
      render: true,
      role: AllowedRole.Risk,
      onClick: () => onClick(ReadingStatus.Risk),
    },
    {
      status: ReadingStatus.Normal,
      count: count?.normal ?? 0,
      active: isNormal,
      label: t('labels.normal'),
      bgColor: '#61B753',
      render: true,
      role: AllowedRole.Risk,
      onClick: () => onClick(ReadingStatus.Normal),
    },
  ];

  if (!isCriticalRole && !isAtRiskRole)
    buttons = buttons.filter((b) => b.render);
  if (isCriticalRole)
    buttons = buttons.filter((b) => b.role === AllowedRole.Critical);
  if (isAtRiskRole)
    buttons = buttons.filter((b) => b.role === AllowedRole.Risk);

  return { buttons, isLoading };
};
